<template>
  <Menu />
  <section id="cookiesPrincipal">
    <Cookies />
  </section>
  <Footer />
</template>

<script>
import Cookies from "@/components/cookies/CookiesPrincipal.vue";
import Menu from "@/components/menu/MenuPrincipal.vue";
import Footer from "@/components/footer/FooterPrincipal.vue";

export default {
  name: "Cookies principal",
  components: {
    Cookies,
    Menu,
    Footer,
  },
};
</script>